<form class="translate-dialog-form astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 class="translate-dialog-form__title">{{ 'TRANSLATE.TRANSLATIONS' | translate }}</h2>

  <div class="astral-stack-m">
    @for (transControl of translations; track transControl) {
      @switch (dataContext.type) {
        @case ('area') {
          <astral-textarea [control]="transControl"></astral-textarea>
        }
        @default {
          <astral-input [control]="transControl"></astral-input>
        }
      }
    }
  </div>

  @if (errorMessage; as error) {
    <div class="translate-dialog-form__error" role="alert">
      {{ error.message | translate: error.params }}
    </div>
  }

  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
